import { LastModifiedCell } from 'ui/indexPages/tables/cells/LastModifiedCell';
import { TableGridRow } from './Styled';
import { SnippetUsage } from '../types';
import { UsageNameCell } from './UsageNameCell';
import { UsageMediumCell } from './UsageMediumCell';
import { UsageCampaignCell } from './UsageCampaignCell';
import { UsageTypeCell } from './UsageTypeCell';

type UsageRowProps = {
  result: SnippetUsage;
  usageRowGrid: string;
};

// Name: TemplateNameCell & ID
// Medium: MessageMedium
// Campaign: CampaignName & ID & State
// Created: TemplateCreator & CreationDate

export const UsageRow = ({ result, usageRowGrid }: UsageRowProps) => {
  const creator = result.creatorUser;
  const modifier = result.updatedByUser;
  const createdBy = { emailAddress: creator.id, ...creator };
  const modifiedBy = modifier ? { emailAddress: modifier.id, ...modifier } : undefined;

  return (
    <TableGridRow gridLayout={usageRowGrid} key={result.id}>
      <UsageNameCell result={result} />
      <UsageMediumCell result={result} />
      <UsageTypeCell result={result} />
      <UsageCampaignCell result={result} />

      <LastModifiedCell
        data-test={'usage-last-modified-cell'}
        createdAt={result.creationDate}
        createdBy={createdBy}
        modifiedAt={result.updatedAt}
        modifiedBy={modifiedBy}
        showAvatar={true}
      />
    </TableGridRow>
  );
};
